<div class="page-surface dashboards-page">
  <div class="container-fluid">
    <div class="dash-header panel">
      <div>
        <h1 class="page-title">Dashboards</h1>
        <p class="text-muted mb-0">Visao geral de leads, fechamentos e gargalos.</p>
      </div>
      <div class="dash-filters">
        <div>
          <label class="form-label">De</label>
          <input class="form-control" type="date" [(ngModel)]="dataDe" />
        </div>
        <div>
          <label class="form-label">Ate</label>
          <input class="form-control" type="date" [(ngModel)]="dataAte" />
        </div>
        <button class="btn btn-primary" (click)="aplicarFiltro()">Aplicar</button>
      </div>
    </div>

    <div class="dash-section">
      <h2 class="section-title">Orcamentos por consultor</h2>
      <div class="dash-top-grid">
        <section class="panel dash-card dash-card--donut" *ngFor="let card of consultorCards">
          <div class="consultor-header">
            <h3 class="h6 mb-0">{{ card.nome }}</h3>
            <span class="pill pill-lead">Consultor</span>
          </div>
          <div class="kpi-grid">
            <div class="kpi-card">
              <div class="kpi-label">Leads</div>
              <div class="kpi-value">R$ {{ card.valorAbertos | number: '1.0-0' }}</div>
            </div>
            <div class="kpi-card">
              <div class="kpi-label">OS abertas</div>
              <div class="kpi-value">R$ {{ card.valorFechados | number: '1.0-0' }}</div>
            </div>
            <div class="kpi-card">
              <div class="kpi-label">Total</div>
              <div class="kpi-value">R$ {{ card.total | number: '1.0-0' }}</div>
            </div>
          </div>
          <div class="donut-area">
            <div class="donut-wrap">
              <canvas
                baseChart
                [data]="card.donutData"
                [type]="'doughnut'"
                [options]="donutOptions"
              ></canvas>
            </div>
          </div>
        </section>

        <section class="panel dash-card dash-card--donut dash-card--geral" *ngIf="geralCard">
          <div class="consultor-header">
            <div>
              <h3 class="h6 mb-0">Todos os consultores</h3>
            </div>
            <span class="pill pill-lead">Geral</span>
          </div>
          <div class="kpi-grid">
            <div class="kpi-card">
              <div class="kpi-label">Leads</div>
              <div class="kpi-value">R$ {{ geralCard.valorAbertos | number: '1.0-0' }}</div>
            </div>
            <div class="kpi-card">
              <div class="kpi-label">OS abertas</div>
              <div class="kpi-value">R$ {{ geralCard.valorFechados | number: '1.0-0' }}</div>
            </div>
            <div class="kpi-card">
              <div class="kpi-label">Total</div>
              <div class="kpi-value">R$ {{ geralCard.total | number: '1.0-0' }}</div>
            </div>
          </div>
          <div class="donut-area">
            <div class="donut-wrap">
              <canvas
                baseChart
                [data]="geralCard.donutData"
                [type]="'doughnut'"
                [options]="donutOptions"
              ></canvas>
            </div>
          </div>
        </section>
      </div>
    </div>

    <div class="dash-section">
      <section class="panel dash-card dash-card--gargalos">
        <h2 class="section-title">Workflow gargalos</h2>
        <div class="chart-wrap gargalos-chart-wrap">
          <canvas baseChart [data]="barData" [type]="'bar'" [options]="barOptions"></canvas>
        </div>
      </section>
    </div>
  </div>
</div>
